const usdFmt = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
const usd2Fmt = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });
const numFmt = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

const ok = (v) => v !== null && v !== undefined && Number.isFinite(Number(v));

export const usd = (v) => (ok(v) ? usdFmt.format(v) : "—");
export const usd2 = (v) => (ok(v) ? usd2Fmt.format(v) : "—");
export const num = (v) => (ok(v) ? numFmt.format(v) : "—");
export const pct = (v) => (ok(v) ? `${Number(v).toFixed(1)}%` : "—");
export const pctFrac = (f) => (ok(f) ? `${(f * 100).toFixed(1)}%` : "n/a");
export const mult = (v) => (ok(v) ? `${Number(v).toFixed(2)}x` : "—");

export function usdCompact(v) {
  if (!ok(v)) return "—";
  const a = Math.abs(v);
  const s = v < 0 ? "-" : "";
  if (a >= 1e6) return `${s}$${(a / 1e6).toFixed(1)}M`;
  if (a >= 1e3) return `${s}$${(a / 1e3).toFixed(0)}K`;
  return `${s}$${a.toFixed(0)}`;
}

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
};

export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "—");

export const fmtSize = (b) => (b > 1e6 ? `${(b / 1e6).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1e3))} KB`);
